import React, { useState, useEffect } from "react";

const Setupa = () => {
  const [ipAddress, setIpAddress] = useState("");
  const [mappings, setMappings] = useState([{ color: "", functionName: "" }]);
  const userEmail = sessionStorage.getItem("userEmail");

  // Fetch IP from DB on load
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://www.hydaxdroid.com/get_rosa_ip", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ gmail: userEmail }),
        });
        if (res.ok) {
          const data = await res.json();
          setIpAddress(data.ip_address || "");
        }
      } catch (err) {
        console.error("Error fetching IP:", err);
      }
    };
    if (userEmail) fetchIp();
  }, [userEmail]);

  const handleMappingChange = (index, field, value) => {
    const newMappings = [...mappings];
    newMappings[index][field] = value;
    setMappings(newMappings);
  };

  const addMapping = () => {
    setMappings([...mappings, { color: "", functionName: "" }]);
  };

  const removeMapping = (index) => {
    setMappings(mappings.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    if (!ipAddress) {
      alert("Please set Relay IP first in Setup Relay IP page!");
      return;
    }

    try {
      const res = await fetch("https://www.hydaxdroid.com/save_relay_setup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gmail: userEmail,
          mappings: mappings, // only mappings here
          // ipAddress is already known from DB
        }),
      });

      const data = await res.json();
      if (res.ok) {
        alert(data.message || "Mappings saved successfully!");
      } else {
        alert(data.error || "Error saving mappings!");
      }
    } catch (err) {
      alert("Error saving mappings!");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <p>Signed in as: {userEmail}</p>
      <h2 className="text-xl font-bold mb-4">Setup Relay</h2>

      {/* Show IP from DB but not mandatory to type again */}
      <input
        type="text"
        placeholder="Relay IP (from DB)"
        value={ipAddress}
        disabled
        className="w-80 p-2 border border-gray-300 rounded mb-4 bg-gray-100"
      />

      {/* Color ? Function mappings */}
      <h3 className="text-lg font-semibold mb-2">Assign Colors to Functions</h3>
      {mappings.map((map, index) => (
        <div key={index} className="flex items-center gap-2 mb-2">
          <input
            type="text"
            placeholder="Color (e.g. red)"
            value={map.color}
            onChange={(e) =>
              handleMappingChange(index, "color", e.target.value)
            }
            className="p-2 border border-gray-300 rounded"
          />
          <input
            type="text"
            placeholder="Function (e.g. safety1)"
            value={map.functionName}
            onChange={(e) =>
              handleMappingChange(index, "functionName", e.target.value)
            }
            className="p-2 border border-gray-300 rounded"
          />
          <button
            onClick={() => removeMapping(index)}
            className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
          >
            ?
          </button>
        </div>
      ))}
      <button
        onClick={addMapping}
        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 mb-4"
      >
        + Add Mapping
      </button>

      <button
        onClick={handleSave}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Save Setup
      </button>
    </div>
  );
};

export default Setupa;
